import { render, staticRenderFns } from "./singleCheckTree.vue?vue&type=template&id=67fcf251&scoped=true&"
import script from "./singleCheckTree.vue?vue&type=script&lang=js&"
export * from "./singleCheckTree.vue?vue&type=script&lang=js&"
import style0 from "./singleCheckTree.vue?vue&type=style&index=0&id=67fcf251&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fcf251",
  null
  
)

export default component.exports